'use client'
import { COUNTRY_CODE, LANG, LANG_REGION, REGION, getStoreByLocale } from '@/utils'
import type { FC, ReactNode, Dispatch, SetStateAction } from 'react'
import { createContext, useMemo, useState } from 'react'

type TypeState = {
  location: {
    lang: string
    langRegion: string
    regionCode: string
    countryCode: string
    name: string
  }
  setLocation: Dispatch<SetStateAction<TypeState['location']>>
}

const initialState: TypeState = {
  location: {
    lang: LANG,
    langRegion: LANG_REGION,
    regionCode: REGION,
    countryCode: COUNTRY_CODE,
    name: getStoreByLocale[LANG_REGION]
  },
  setLocation: () => {},
}

type Props = {
  children: ReactNode
}

export const LocationContext = createContext<TypeState | null>(initialState)

export const LocationProvider: FC<Props> = ({ children }) => {
  const [location, setLocation] = useState<TypeState['location']>(initialState.location)
  const value = useMemo(() => ({ location, setLocation }), [location])

  return <LocationContext.Provider value={value}>{children}</LocationContext.Provider>
}
